var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.497 41.43V16.503a2.198 2.198 0 0 0-2.197-2.198H35.308a2.198 2.198 0 0 1-2.15-1.744l-.768-3.64a2.198 2.198 0 0 0-2.15-1.745H11.006A2.198 2.198 0 0 0 8.81 9.375v8.884",
    stroke: "#35404A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.864 39.863v-11.94a2.198 2.198 0 0 0-2.197-2.197H28.675a2.198 2.198 0 0 1-2.15-1.744l-.768-3.64a2.198 2.198 0 0 0-2.15-1.745H4.374a2.198 2.198 0 0 0-2.197 2.198v37.824c0 1.214.984 2.198 2.197 2.198H42.84M2.32 31.595h56.964",
    stroke: "#35404A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.528,
    cy: 57.252,
    r: 16.998,
    stroke: "#35404A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m73.707 72.485 1.891 2.037M76.251 68.128l2.774.176M69.173 74.702l-.029 2.779",
    stroke: "#31B59F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.528 67.252a1.5 1.5 0 0 0 1.5-1.5v-7h7a1.5 1.5 0 0 0 0-3h-7v-7a1.5 1.5 0 0 0-3 0v7h-7a1.5 1.5 0 0 0 0 3h7v7a1.5 1.5 0 0 0 1.5 1.5z",
    fill: "#31B59F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07 21.445a1 1 0 0 1 1-1h17.918a1 1 0 0 1 .98.801l.63 3.104a4 4 0 0 0 1.075 2.014l.13.131H4.07v-5.05z",
    fill: "#31B59F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.17f483fa576031085c86ec00cbeb3594.svg";
export { ForwardRef as ReactComponent };